// extracted by mini-css-extract-plugin
export default {"img":"ProfilCard_img__zOgZG","info":"ProfilCard_info__2UHT9"};